// extracted by mini-css-extract-plugin
export default {"page":"page_page__HUAyt","bookList":"page_bookList__G9-zp","heading":"page_heading__L2FEj"};